import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService, UserService } from '@ca/core/services';

/**
 * This component is used for the route '/implicit-login' in order to automatically redirect
 * the user to login page. We need that because we need to call a login from the Webflow
 * application.
 */
@Component({
    selector: 'ca-implicit-login',
    templateUrl: './implicit-login.component.html',
    styleUrls: ['./implicit-login.component.scss'],
})
export class ImplicitLoginComponent implements OnInit {
    constructor(
        private authService: AuthenticationService,
        private userService: UserService,
        private router: Router,
    ) {}
    ngOnInit(): void {
        if (!this.userService.isLoggedIn) {
            this.authService.login();
        } else {
            this.router.navigate(['/ai-toolkit/overview']);
        }
    }
}
